import { FileType, FILE_TYPES } from '../constants/file-types.constant';

export type ProviderFormData = {
  // File Identification
  configName: string;
  providerName: string;
  fileNamePattern: string;
  fileType: FileType;
  clientColumn: string; // Conditionally required based on fileType
  clientIdentifier: string; // Conditionally required based on fileType
  insurerIdentifier: string; // Conditionally required based on fileType
  lineOfBusiness: string[];
  contentType: string;
  permittedUse: string;
  cadenceTimeframe: string;
  cadenceDay: string;

  // File Processing
  fileFormat: string;
  separator: string;
  hasHeader: boolean;

  // Fixed Width Config
  fixedWidthConfig: string; // Conditionally required when fileFormat is 'fixed_width_txt'
};

export const DEFAULT_FORM_VALUES: ProviderFormData = {
  configName: '',
  providerName: '',
  fileNamePattern: '',
  fileType: FILE_TYPES.SINGLE_CLIENT_SINGLE_INSURER,
  clientColumn: '',
  clientIdentifier: '',
  insurerIdentifier: '',
  lineOfBusiness: [],
  contentType: '',
  permittedUse: '',
  cadenceTimeframe: '',
  cadenceDay: '',
  fileFormat: 'csv',
  separator: ',',
  hasHeader: true,
  fixedWidthConfig: '',
};
